import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as PlantillasContabilidadService from 'services/plantillaContabilidad.service'

import { IdGen } from 'utils'

import MainForm from './mainForm'

const portletBreadcrumbs = [{ name: 'Plantillas', path: `/${CodigosTransaccionesConstant.PLANTILLASCONTABILIDAD_LISTA}` }, { name: 'Nuevo' }]

const NuevoPage = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [_mainFormKey, setMainFormKey] = React.useState(IdGen.newId())

  const editarDataRef = React.useRef({})

  React.useEffect(() => {
    if (match.params.id) {
      PlantillasContabilidadService.getxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = {
            ...data,
            _id: match.params.id
          }
          setMainFormKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [__zariContext, match.params.id])

  return (
    <Portlet>
      <Portlet.Header title='Plantillas' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm key={_mainFormKey} editarData={editarDataRef.current} />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoPage)
